export const TEST_ID = 'drawerHead';

export const AIRWORTHY_CONTROL_TEST_ID = 'drawerHeadAirworthyControl';

export const LIFECYCLE_CONTROL_TEST_ID = 'drawerHeadLifecycleControl';
